export const LOOKUP_ADDRESS_FAILURE = 'LOOKUP_ADDRESS.FAILURE';
export const FETCH_ME_SUCCESS = 'FETCH_ME.SUCCESS';

export interface LookupAddressFailure {
  type: typeof LOOKUP_ADDRESS_FAILURE;
  code: string;
}

export type AddressActionTypes = LookupAddressFailure;
